(function () {
  angular
    .module('specsguardApp')
    .service('errorMessageService', errorMessageService);

  errorMessageService.$inject = ['$mdToast', '$window', 'Labels'];

  function errorMessageService ($mdToast, $window, Labels) {
    return {
      errorMessages: {
        'wrong credentials': Labels.getPlural('wrongcredential'),
        'found no source vals that are in list of to copy inputs': Labels.getPlural('notsourcevalueknown'),
        'Project does not contain specified user': Labels.getLabel('usernotfoundinproject'),
        'need to be authenticated': Labels.getLabel('needtobeauthenticated'),
        'token expired': Labels.getLabel('needtobeauthenticated'),
        'cannot deactivate module because the module has active submodules': Labels.getLabel('cannotdeactivatemodule'),
        'user deactivated': Labels.getLabel('userdeactivated'),
        'user not found': Labels.getLabel('emailaddressunknown') +  ' ' + Labels.getLabel('askadministrator'),
        'user not activated': Labels.getLabel('emailaddressnotactivated'),
        'Server error, probeer aub opnieuw': Labels.getLabel('servererror'),
        'Insufficient project rights': Labels.getLabel('insufficientprojectrights'),
        'Insufficient project rights 403': Labels.getLabel('insufficientprojectrights'),
        'Niet genoeg toegangsrechten': Labels.getLabel('insufficientaccessrights'),
        'A failure occured while saving': Labels.getLabel('saveerror'),
        'email address already in use': Labels.getLabel('userisdeactivated'),
        'Fout tijdens aangemaken of bewerken van module': Labels.getLabel('addediterror'),
        'Fout bij aanmaken van ruimte template': Labels.getLabel('errorcreationareatemplate'),
        invalidtoken: Labels.getLabel('invalidtoken'),
        projectUpdated: Labels.getLabel('projectajusted') + ' ' + Labels.getLabel('reloadpage'),
        projectlistUpdated: Labels.getLabel('projectListUpdated'),
        elementUpdated: Labels.getLabel('specificationUpdated'),
        elementlistUpdated: Labels.getLabel('specificationlistupdated'),
        moduleUpdated: Labels.getLabel('moduleUpdated'),
        modulelistUpdated: Labels.getLabel('moduleListUpdated'),
        buildingUpdated: Labels.getLabel('buildingUpdated'),
        buildinglistUpdated: Labels.getLabel('buildingListUpdated'),
        clusterUpdated: Labels.getLabel('clusterUpdated'),
        clusterlistUpdated: Labels.getLabel('clusterListUpdated'),
        areaUpdated: Labels.getLabel('areaUpdated'),
        arealistUpdated: Labels.getLabel('areaListUpdated'),
        areatemplateUpdated: Labels.getLabel('areatemplateupdated'),
        areatemplatelistUpdated: Labels.getLabel('areatemplatelistupdated'),
        projectRenewed: Labels.getLabel('projectrenewed'),
        invalidvalue: Labels.getLabelCapFirstLetter('invalidvalue'),
        areaListUpdated2: Labels.getLabelCapFirstLetter('areaListUpdated2')
      },

      showToast: function (contentText, toastType, action = Labels.getLabel('close'), allowClose = true) {
        $mdToast.show($mdToast.simple({parent: document.getElementById('toast-container')})
          .textContent(contentText)
          .action(action)
          .highlightAction(true)
          .highlightClass('md-accent')
          .position('bottom right')
          .toastClass('sg-toast')
          .hideDelay(allowClose ? 3000 : 0));
      },

      /**
       * @method getErrorMessage
       * @param {string} str - Raw error message
       * @returns An end-user friendly string
       * */
      getErrorMessage: function (str) {
        if (angular.isUndefined(this.errorMessages[str])) {
          return Labels.getLabel('unknownerror');
        }
        return this.errorMessages[str];
      },

      /**
       * @method showWarning
       * @param {string} str - Raw error message
       * @param {Boolean} action - show a close button. Defaults to true
       * @param {Boolean} allowClose - allow toastr to be closed automatically after 3000ms. Defaults to true
       *
       * Converts string to end-user friendly str and shows a mdToast message
       * */
      showWarning: function (str, action, allowClose) {
        this.showToast(this.getErrorMessage(str), Labels.getLabel('warning'), action, allowClose);
      },

      /**
       * @method showSuccess
       * @param {string} str - End-user ready string
       *
       * Shows a mdToast success message
       * */
      showSuccess: function (str) {
        this.showToast(str, Labels.getLabel('succes'));
      },

      /**
       * @method showError
       * @param {string} str - Raw error message
       *
       * Converts string to end-user friendly str and shows a mdToast message
       * */
      showError: function (str) {
        this.showToast(this.getErrorMessage(str), Labels.getLabel('error'));
      },

      /**
       * @method showInfo
       * @param {string} str - End-user ready string
       *
       * Shows a mdToast info message
       * */
      showInfo: function (str) {
        this.showToast(str, Labels.getLabel('information'));
      }
    };
  }
})();
